module.exports = function(TomSelect) {

	const otpInput = document.getElementById("otp-input");
	otpInput.addEventListener("input", function() {

		this.value = this.value.replace(/[^0-9]/g, "");
	})

	const emailInput = document.getElementById("existing-email-input");

	if ( emailInput == null ) {
		
		return false;
	}

	emailInput.addEventListener("blur", function() {

		const loadingCnt = document.getElementById("loading-existing-email-verification");
		const errorCnt = document.getElementById("invalid-existing-email");

		if ( this.value.trim().length < 10 ) {
			
			return false;
		}

		errorCnt.classList.add("hidden");
		loadingCnt.classList.remove("hidden");

		axios.post("/verify-email", {
			email: this.value
		})
		.then( res => {

			const {ReasonCode, ClientMessage} = res.data;

			if ( ReasonCode != 0 ) {

				loadingCnt.classList.add("hidden");
				errorCnt.textContent = ClientMessage;
				errorCnt.classList.remove("hidden");
			}
		})
		.catch(err => console.log(err))
		.then(() => {

			loadingCnt.classList.add("hidden");
		})
	});

	const mobileInput = document.getElementById("existing-mobile-number");
	mobileInput.addEventListener("input", function() {

		this.value = this.value.replace(/[^0-9]/g, "");
	});

	const homePhoneInput = document.getElementById("existing-home-phone");
	homePhoneInput.addEventListener("input", function() {
		
		this.value = this.value.replace(/[^0-9]/g, "");
	});

	const customerDaySelect = new TomSelect("#existing-day-picker", {
		// allowEmptyOption: true
		onChange: customerDateSelectHandler,
		render: {
			no_results: function(data, escape) {
				return "<div class='no-results'>" + escape(this.input.dataset.noRecords) + "</div>";
			}
		}
	});
	
	const customerMonthSelect = new TomSelect("#existing-month-picker", {
		// allowEmptyOption: true
		onChange: customerDateSelectHandler,
		render: {
			no_results: function(data, escape) {
				return "<div class='no-results'>" + escape(this.input.dataset.noRecords) + "</div>";
			}
		}
	});
	
	const customerYearSelect = new TomSelect("#existing-year-picker", {
		// allowEmptyOption: true,
		maxOptions: 200,
		onChange: customerDateSelectHandler,
		render: {
			no_results: function(data, escape) {
				return "<div class='no-results'>" + escape(this.input.dataset.noRecords) + "</div>";
			}
		}
	});
	
	new TomSelect("#existing-citizenship", {
		// allowEmptyOption: true,
		maxOptions: 200,
		render: {
			no_results: function(data, escape) {
				return "<div class='no-results'>" + escape(this.input.dataset.noRecords) + "</div>";
			}
		}
	});

	function customerDateSelectHandler() {

		const date = `${customerYearSelect.getValue()}-${customerMonthSelect.getValue()}-${customerDaySelect.getValue()}`;
		document.getElementById("existing-birthday-input").value = date;
	}
};